import React from 'react'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import { format } from 'date-fns'

import { BoldSmallBodyText, Subheading } from '../styles/Text'
import { FlexColumn, SpaceBetweenRowContainer, MedBGContainer, WhiteBGContainer } from '../styles/Containers'
import BrowserFile from '../files/BrowserFile'
import DatabaseFile from '../files/DatabaseFile'

const Container = styled(FlexColumn)`
  container-type: inline-size;
`

const Item = styled(SpaceBetweenRowContainer)`
  align-items: flex-start;

  @media only screen and (max-width: 600px) {
    flex-wrap: nowrap;
  }
  @container (max-width: 600px) {
    flex-wrap: nowrap;
  }
  @container (max-width: 500px) {
    flex-wrap: wrap;
  }
`

const Label = styled(BoldSmallBodyText)`
  width: 40%;

  @container (max-width: 500px) {
    width: 100%;
  }
`

const Value = styled.div`
  width: 60%;
  text-wrap: wrap;
  word-break: break-word;
  font-size: 12px;

  @container (max-width: 500px) {
    width: 100%;
  }
`

function renderDatabaseFile(key, value, useWhiteFileBg) {
  const Container = useWhiteFileBg ? WhiteBGContainer : MedBGContainer
  return (
    <Container key={key} padding="5px 15px 5px 5px">
      <DatabaseFile file={value} spacing="medium" buttonAction="download" />
    </Container>
  )
}

function renderBrowserFile(key, value, useWhiteFileBg) {
  const Container = useWhiteFileBg ? WhiteBGContainer : MedBGContainer
  return (
    <Container key={key} padding="0">
      <BrowserFile file={value} showButton={false} />
    </Container>
  )
}

function renderItem(key, label, value) {
  return (
    <Item key={key} gap="5px 15px">
      <Label>{label}</Label>
      <Value>{value}</Value>
    </Item>
  )
}

function renderDate(key, label, value) {
  return (
    <Item key={key} gap="5px 15px">
      <Label>{label}</Label>
      <Value>{format(value, 'MMM-dd-yyyy hh:mm a')}</Value>
    </Item>
  )
}

function DetailSection({ sectionLabel, details, useWhiteFileBg = false }) {
  return (
    <Container gap="15px">
      {sectionLabel && <Subheading>{sectionLabel}</Subheading>}
      <FlexColumn gap="10px">
        {Object.entries(details).map(([key, value]) => {
          if (Array.isArray(value)) {
            return value.map((detail, i) => {
              if (detail instanceof Date) {
                return renderDate(`${key}-${i}`, key, detail)
              } else if (detail instanceof File) {
                return renderBrowserFile(`${key}-${i}`, detail, useWhiteFileBg)
              } else if (detail.id && detail.filename && detail.usage) {
                return renderDatabaseFile(`${key}-${i}`, detail, useWhiteFileBg)
              } else {
                return renderItem(`${key}-${i}`, key, detail)
              }
            })
          } else if (value instanceof Date) {
            return renderDate(key, key, value)
          } else if (value instanceof File) {
            return renderBrowserFile(key, value, useWhiteFileBg)
          } else if (value.id && value.filename && value.usage) {
            return renderDatabaseFile(key, value, useWhiteFileBg)
          } else {
            return renderItem(key, key, value)
          }
        })}
      </FlexColumn>
    </Container>
  )
}

DetailSection.propTypes = {
  sectionLabel: PropTypes.string,
  details: PropTypes.object.isRequired,
  useWhiteFileBg: PropTypes.bool
}

export default DetailSection
